import { h, Fragment } from "preact";
import { useMemo } from "preact/hooks";
import sortMaterials from "../../helpers/sortMaterials/sortMaterials";
import ProductOptionSwatchesGroup from "./product-option-swatches-group";
import ProductOptionSummary from "./product-option-summary";

const sortMto = (groupA, groupB) => {
  if (groupA.madeToOrder === groupB.madeToOrder)
    return sortMaterials(
      groupA.optionValues[0].materialGroup,
      groupB.optionValues[0].materialGroup,
    );

  if (groupA.madeToOrder) return 1;

  return -1;
};

export default function ProductOptionSwatchesGrouped({
  optionValues,
  optionName,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  variantsByOptionValue = [],
  unavailableOptionValues = [],
  selectedVariant,
  openByDefault,
  last,
  enableSwatchPreview,
  disabledSwatchStyle,
  optionSize,
}) {
  const optionsByGroup = useMemo(() => {
    const groups = {};
    optionValues.forEach((optionValue) => {
      if (!optionValue.materialGroup) {
        // Group any missing groups under the option name
        optionValue.materialGroup = optionName;
      }

      const key = optionValue.madeToOrder
        ? window.localeStrings.product.made_to_order_material.replace(
            "[material]",
            optionValue.materialGroup,
          )
        : optionValue.materialGroup;

      if (!(key in groups)) {
        groups[key] = {
          optionValues: [],
          madeToOrder: optionValue.madeToOrder,
        };
      }

      groups[key].optionValues.push(optionValue);
    });

    return groups;
  }, [optionValues, optionName]);

  return (
    <conditional-details>
      <details
        className={`product-options__option-details ${last ? "product-options__option-details--last" : ""} product-options__swatches-grouped`}
        open={openByDefault}
      >
        <ProductOptionSummary
          optionName={optionName}
          selectedOptionValue={selectedOptionValue}
          optionValuesCount={optionValues.length}
        />
        <div className="product-options__option-content" data-content>
          <div className="product-options__option-content-inner">
            <div className="product-options__swatch-groups">
              {Object.entries(optionsByGroup)
                .sort(([_a, groupA], [_b, groupB]) => sortMto(groupA, groupB))
                .map(([groupTitle, { optionValues, madeToOrder }]) => (
                  <ProductOptionSwatchesGroup
                    groupTitle={groupTitle}
                    madeToOrder={madeToOrder}
                    optionValues={optionValues}
                    selectedOptionValue={selectedOptionValue}
                    selectedVariant={selectedVariant}
                    variantsByOptionValue={variantsByOptionValue}
                    disabledOptionValues={disabledOptionValues}
                    unavailableOptionValues={unavailableOptionValues}
                    updateOptionValue={updateOptionValue}
                    optionName={optionName}
                    enableSwatchPreview={enableSwatchPreview}
                    disabledSwatchStyle={disabledSwatchStyle}
                    optionSize={optionSize}
                  />
                ))}
            </div>
          </div>
        </div>
      </details>
    </conditional-details>
  );
}
